module.exports = __webpack_public_path__ + "9f5be81f29e54680e4980f6f54148078.gif";